module.exports = __webpack_public_path__ + "img/10_61.0f458ec8.png";